import AvailableDateRange from './AvailableDateRange';
import ExchangeRates, { TimePeriod } from './ExchangeRates';
import Rate from './Rate';

interface RawExchangeRates {
	id: string;
	name: string;
	type: string;
	availableDateRange: {
		since: string;
		until: string;
	} | null;
	baseCurrency: string;
	date: string;
	exchangeRates: {
		currency: string;
		factor: string;
	}[];
	timePeriod: TimePeriod;
}

export default function mapExchangeRates(rates: RawExchangeRates): ExchangeRates {
	return new ExchangeRates(
		rates.id,
		rates.name,
		rates.type,
		rates.availableDateRange !== null
			? new AvailableDateRange(new Date(rates.availableDateRange.since), new Date(rates.availableDateRange.until))
			: null,
		rates.baseCurrency,
		new Date(rates.date),
		rates.exchangeRates.map((rate) => new Rate(rate.currency, rate.factor)),
		rates.timePeriod
	);
}
